import moment from "moment";
import React from "react";

const Footer = () => {
    return (
        <footer>
            <div className="fullWidth">
                <div className="copyright">Copyright © {`${moment().format('YYYY')}`} Haploscope - All Rights Reserved</div>
            </div>  
        </footer>
    )
}

export default Footer